/**
 * Button
 */

// eslint-disable-next-line
import $ from 'jquery';

// Custom
import 'protons';

// Module template
import './_button.twig';
import './_button.css';

export const name = 'button';

export function disable() {}

// eslint-disable-next-line
export function enable($context) {}

export default enable;
